export const MODULE_NAME = 'travel-personalized-marketing-articles';

export const ADS_MODULE_NAME = 'axp-personalized-marketing';
export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const WISHLIST_MODULE_NAME = 'travel-wishlist-modal';

export const ONE_DATA_FUNCTION_NAME = 'ReadGetPersonalizedMarketingArticles.v1';

export const CLIENT_IDS = {
  HOMEPAGE_CLIENT: 'homepage',
  LUXURY_HOTELS_CLIENT: 'luxury-hotels', // FHR
  LUXURY_HOTELS_DEDICATED_CLIENT: 'luxury-hotels-dedicated', // FHR/THC platinum,
  SUMMARY_CLIENT: 'summary', // PBSS
};

export const clients = new Set([
  CLIENT_IDS.HOMEPAGE_CLIENT,
  CLIENT_IDS.LUXURY_HOTELS_CLIENT,
  CLIENT_IDS.SUMMARY_CLIENT,
  // add below clients once they are set up with the oneData function
  // CLIENT_IDS.LUXURY_HOTELS_DEDICATED_CLIENT,
]);

export const PLACEMENT_IDS = {
  FOR_YOU_PLACEMENT: 'for-you',
  GET_INSPIRED_PLACEMENT: 'get-inspired',
  HOTEL_OFFERS_PLACEMENT: 'hotel-offers',
};

export const placements = new Set([
  PLACEMENT_IDS.GET_INSPIRED_PLACEMENT,
  // add below placements once they are set up with the oneData function
  // PLACEMENT_IDS.FOR_YOU_PLACEMENT,
  // PLACEMENT_IDS.HOTEL_OFFERS_PLACEMENT,
]);

// can convert to a switch statement if more 'grid' placements are added in the future
export const placementIdToLayout = (placementId: string) => (
  PLACEMENT_IDS.HOTEL_OFFERS_PLACEMENT === placementId ? 'grid' : 'row');

// Experiments
export const MOSAIC_GET_INSPIRED_EXPERIMENT = 'prebooking_home_mosaic_get_inspired_user';
